import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('change', '#id_pickup_day', function() {
  const selectedDay = $(this).val();
  if (selectedDay === 'next') {
    $('#id_pickup_hour option').each((idx, option) => {
      option.disabled = false;
    });
  } else {
    const hours = $('#id_pickup_hour').attr('data-today-hours').split(',');
    $('#id_pickup_hour option').each((idx, option) => {
      option.disabled = !hours.includes(option.value);
    });
  }
});

$(document).on('change', '#id_pickup_hour', function() {
  const selectedHour = parseInt($(this).val(), 10);
  const timestamp = new Date();
  const hours = timestamp.getHours();
  const minutes = timestamp.getMinutes();
  const m = minutes + 30;

  $('#id_pickup_minute option').each((idx, option) => {
    const val = option.value;
    option.disabled = false;
    if (selectedHour === hours) {
      if (m >= 60) {
        option.disabled = true;
      } else if (val < m % 60) {
        option.disabled = true;
      }
    } else if (selectedHour === hours + 1 && m >= 60) {
      if (m % 60 > val) {
        option.disabled = true;
      }
    }
  });
});

$(document).ready(() => {
  $('#id_pickup_day').trigger('change');
  $('#id_pickup_hour').trigger('change');
});

$(document).on('change', '#id_customer_object', function() {
  let $costcenter = $('[data-costcenter-target="checkout"][data-costcenter-reset]');
  if ($costcenter.length > 0 && $(this).val().length > 0) {
    $costcenter.trigger('click');
  } else {
    $costcenter = $('#id_costcenter');
    if ($costcenter.length > 0 && $(this).val().length > 0) {
      $costcenter.val('');
    }
  }
  if ($(this).val().length > 0) {
    $(this).closest('[data-checkout-update-form]').submit();
  }
});

$(document).on('change', '#id_costcenter', function() {
  $('[data-costcenter-target="checkout"][data-costcenter-reset]').toggleClass('hide', !$(this).val());
  const $object = $('[data-object-target="checkout"][data-object-reset]');
  if ($object.length > 0 && $(this).val().length > 0) {
    $object.trigger('click');
  }
  if ($(this).val().length > 0) {
    $(this).closest('[data-checkout-update-form]').submit();
  }
});

$(document).on('click', '[data-costcenter-target="checkout"][data-costcenter-set]', function (event) {
  event.preventDefault();
  let value = $(this).attr('data-costcenter-set');
  const text = $(this).attr('data-costcenter-text');

  if (text !== undefined) {
    $('#id_costcenter').val(value).trigger('change');
    $('#id_costcenter_text').html(text);
  } else {
    const input = $(this).closest('[data-table-oninput]');
    value = input.find('[data-table-search-query]').text();
    $('#id_costcenter').val(value).trigger('change');
    $('#id_costcenter_text').html(value);
  }
  $(this).closest('[data-reveal]').foundation('close');
});

$(document).on('click', '[data-costcenter-target="checkout"][data-costcenter-reset]', (event) => {
  event.preventDefault();
  $('#id_costcenter').val('').trigger('change');
  $('#id_costcenter_text').html('----------');
});

$(document).on('click', '[data-checkout-button]', (event) => {
  event.preventDefault();
  $('[data-checkout-form]').submit();
});

$(document).on('click', '[data-object-select-trigger]', function (event) {
  event.preventDefault();
  $(this).parent().find('[data-object-select]').trigger('click');
});

$(document).on('click', '[data-costcenter-select-trigger]', function (event) {
  event.preventDefault();
  $(this).parent().find('[data-costcenter-select]').trigger('click');
});

$(document).on('click', '[data-checkout-confirm-message-abort]', function(event) {
  event.preventDefault();
  const $reveal = $(this).closest('[data-reveal]');
  $reveal.addClass('loading');

  $.ajax({
    url: $(this).attr('data-checkout-confirm-message-abort'),
    type: 'POST',
    data: {
      csrfmiddlewaretoken: $('meta[name="csrf-token"]').attr('content'),
    },
  }).then((resp) => {
    if (resp.status) {
      $reveal.removeAttr('data-checkout-confirm-messages');
      $('[data-checkout-form]').submit();
    } else {
      $.stores.checkout.load($(this).attr('href'));
    }
  });
});

$(document)
  .off('submit', '[data-checkout-update-form]')
  .on('submit', '[data-checkout-update-form]', function(event) {
    event.preventDefault();
    if (this.disabled) {
      return;
    }

    const $form = $(this);
    const $widget = $form.closest('[data-checkout-step]');
    load(
      $widget,
      $.stores.checkout.load($form.attr('action'), new FormData(this)),
    ).then(() => {
      $('#id_pickup_day').trigger('change');
      $('#id_pickup_hour').trigger('change');
    });
    this.disabled = true;
  });

$(document)
  .off('click', '[data-checkout-edit]')
  .on('click', '[data-checkout-edit]', function(event) {
    event.preventDefault();
    const $this = $(this);

    if ($this.is('.disabled')) {
      return;
    }

    const $widget = $this.closest('[data-checkout-step]');
    load(
      $widget,
      $.stores.checkout.load($this.attr('href')),
    ).then(() => {
      const $searchTableInput = $('input[data-search-table]').first();
      if ($searchTableInput.length) {
        $searchTableInput.focus();
      }
      $('#id_pickup_day').trigger('change');
      $('#id_pickup_hour').trigger('change');
    });
  });
